// Helper function to process video accessibility for a container
function processVideoAccessibility(container, containerName) {
  const lsVideo = container.querySelector('#ls-video');
  
  if (lsVideo && !lsVideo.hasAttribute('aria-labelledby')) {
    lsVideo.setAttribute('aria-labelledby', 'ls-detail-caption');
    
    const lsDetailCaption = document.querySelector('.ls-detail-caption');
    if (lsDetailCaption) {
      lsDetailCaption.setAttribute('id', 'ls-detail-caption');
    }
  }
}

// Function to handle accessibility attributes
function handleLsVideoAccessibility() {
  const containers = [
    { selector: '#ls-slider-popup-container', name: '#ls-slider-popup-container' },
    { selector: '#ls-popup-container', name: '#ls-popup-container' }
  ];
  
  containers.forEach(({ selector, name }) => {
    const container = document.querySelector(selector);
    if (container) {
      processVideoAccessibility(container, name);
    }
  });
}

// Dynamically inject/remove the loading announcement text in the predictive-search
// live region. Static content already present in the DOM when a live region becomes
// visible is never announced by screen readers — only newly added content is.
(function () {
  function syncLoadingAnnouncement(el) {
    var announcement = el.querySelector('.js-loading-announcement');
    if (!el.hasAttribute('hidden')) {
      if (!announcement) {
        var span = document.createElement('span');
        span.className = 'visually-hidden js-loading-announcement';
        span.textContent = el.dataset.loadingText || 'Loading search results';
        el.appendChild(span);
      }
    } else if (announcement) {
      announcement.remove();
    }
  }

  function attachLoadingObserver(el) {
    if (el.dataset.loadingObserverAttached) return;
    el.dataset.loadingObserverAttached = 'true';
    new MutationObserver(function () {
      syncLoadingAnnouncement(el);
    }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initLoadingAnnouncements() {
    document.querySelectorAll('.predictive-search__loading-state').forEach(attachLoadingObserver);
  }

  initLoadingAnnouncements();
  new MutationObserver(initLoadingAnnouncements).observe(document.body, { childList: true, subtree: true });
})();

// Watch for #ls-slider-popup-container
const lsSliderObserver = new MutationObserver((mutations) => {
  handleLsVideoAccessibility();
});

lsSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Update Flickity page dots aria-labels from 'Page dot' to 'Slide', and set ARIA roles
function updateFlickityDotsAriaLabels() {
  const containers = document.querySelectorAll('.flickitylf-page-dots');
  containers.forEach((container) => {
    if (!container.hasAttribute('role')) {
      container.setAttribute('role', 'presentation');
    }
  });

  const dots = document.querySelectorAll('.flickitylf-page-dots .dot');
  dots.forEach((dot) => {
    if (!dot.hasAttribute('role')) {
      dot.setAttribute('role', 'button');
    }
    const ariaLabel = dot.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.includes('Page dot')) {
      dot.setAttribute('aria-label', ariaLabel.replace('Page dot', 'Slide'));
    }
  });
}

// Run on page load
updateFlickityDotsAriaLabels();

// Watch for dynamically added dots
let flickityDotsUpdateScheduled = false;
const flickityDotsObserver = new MutationObserver(() => {
  if (flickityDotsUpdateScheduled) return;
  flickityDotsUpdateScheduled = true;
  requestAnimationFrame(() => {
    flickityDotsUpdateScheduled = false;
    updateFlickityDotsAriaLabels();
  });
});

flickityDotsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Sync tabindex on focusable children whenever a carousel cell's aria-hidden changes.
// Flickity sets aria-hidden="true" on non-selected cells but leaves their focusable
// descendants keyboard-reachable, causing WCAG SC 1.3.1 / 4.1.2 violations.
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function syncCellFocusability(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-tabindex-saved')) {
          var orig = el.getAttribute('tabindex');
          el.setAttribute('data-tabindex-saved', orig !== null ? orig : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-tabindex-saved')) {
        var saved = el.getAttribute('data-tabindex-saved');
        if (saved === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', saved);
        }
        el.removeAttribute('data-tabindex-saved');
      }
    });
  }

  function attachCellObserver(cell) {
    if (cell.dataset.ariaHiddenGuard) return;
    cell.dataset.ariaHiddenGuard = 'true';
    syncCellFocusability(cell);
    new MutationObserver(function () {
      syncCellFocusability(cell);
    }).observe(cell, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function attachToAllCells() {
    document.querySelectorAll('.carousel-cell').forEach(attachCellObserver);
  }

  attachToAllCells();

  new MutationObserver(attachToAllCells).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// Add focus class to kt-image-item-box when kt-image-link is focused
function setupImageLinkFocus() {
  document.querySelectorAll('.kt-image-link, .kt-image-lightbox').forEach((link) => {
    if (link.dataset.focusListenerAdded) return;
    link.dataset.focusListenerAdded = 'true';
    
    link.addEventListener('focus', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.add('has-focus-within');
    });
    
    link.addEventListener('blur', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.remove('has-focus-within');
    });
  });
}

// Run on page load
setupImageLinkFocus();

// Watch for dynamically added links
const imageLinkObserver = new MutationObserver(() => {
  setupImageLinkFocus();
});

imageLinkObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Product-media Flickity gallery — complete the WAI-ARIA carousel slide pattern.
// The gallery container carries role="region"/aria-roledescription="carousel" and
// each cell carries role="group"/aria-roledescription="slide" from Liquid, but three
// things must be done at runtime because the visible slide set changes as the
// shopper switches variants:
//   1. Give each visible slide a "N of M" accessible name (M is variant-dependent).
//   2. Hide variant-filtered cells from assistive tech. Flickity's cellSelector
//      excludes .is-filtered cells from the track, so it never marks them
//      aria-hidden and they would otherwise be announced as extra slides.
//   3. Take the off-screen slides out of the page entirely once the carousel has
//      settled (see hideOffscreenSlides).
// We never touch aria-hidden on the real (non-filtered) slides — Flickity owns that
// so only the current slide is exposed — using a data marker to tell our own
// aria-hidden apart from Flickity's when a cell flips back to non-filtered.
(function () {
  var OFFSCREEN_CLASS = 'is-ada-offscreen';

  // Slides that are not on screen must be unreachable, not merely unannounced:
  // Flickity only sets aria-hidden, which still leaves a slide's focusable content
  // (a video play button, a model viewer) in the tab order. The class adds
  // visibility: hidden, which removes both.
  //
  // Timing matters. Flickity flips is-selected/aria-hidden when a slide is *chosen*,
  // while the outgoing slide is still animating out of view, so hiding on that
  // signal would make it vanish mid-flight (and dragging would pull in blank
  // space). So every cell is revealed as soon as the carousel starts moving and
  // only re-hidden on the "settle" event, when nothing is in motion.
  function hideOffscreenSlides(carousel) {
    if (!carousel.classList.contains('flickity-enabled')) return;

    carousel.querySelectorAll('.product__media-item').forEach(function (item) {
      item.classList.toggle(
        OFFSCREEN_CLASS,
        !item.classList.contains('is-selected')
      );
    });
  }

  function revealAllSlides(carousel) {
    carousel.querySelectorAll('.' + OFFSCREEN_CLASS).forEach(function (item) {
      item.classList.remove(OFFSCREEN_CLASS);
    });
  }

  function watchSlideVisibility(carousel) {
    if (carousel.dataset.adaSlideVisibility) return;
    carousel.dataset.adaSlideVisibility = 'true';

    // Fires on init and again after a variant change reloads the carousel.
    carousel.addEventListener('flickity:ready', function () {
      hideOffscreenSlides(carousel);
    });
    carousel.addEventListener('flickity:slide-settled', function () {
      hideOffscreenSlides(carousel);
    });
    carousel.addEventListener('flickity:slide-changed', function () {
      revealAllSlides(carousel);
    });
    // A drag moves the cells before it crosses the threshold that changes slide,
    // so uncover them as soon as the pointer goes down.
    carousel.addEventListener('pointerdown', function () {
      revealAllSlides(carousel);
    });

    // Flickity may already be initialised by the time this script runs, in which
    // case its "ready" event has been and gone.
    hideOffscreenSlides(carousel);
  }

  function enhanceGallery(carousel) {
    watchSlideVisibility(carousel);

    var items = carousel.querySelectorAll('.product__media-item');
    var visible = [];

    items.forEach(function (item) {
      if (item.classList.contains('is-filtered')) {
        if (item.getAttribute('aria-hidden') !== 'true') {
          item.setAttribute('aria-hidden', 'true');
        }
        item.setAttribute('data-ada-filtered-hidden', 'true');
      } else {
        // Only clear aria-hidden that we set for filtering; leave Flickity's alone.
        if (item.hasAttribute('data-ada-filtered-hidden')) {
          item.removeAttribute('aria-hidden');
          item.removeAttribute('data-ada-filtered-hidden');
        }
        visible.push(item);
      }
    });

    var total = visible.length;

    visible.forEach(function (item, index) {
      var labelId = item.id ? item.id + '-slide-label' : '';
      var label = item.querySelector(':scope > .product__media-slide-label');

      if (!label) {
        label = document.createElement('span');
        label.className = 'visually-hidden product__media-slide-label';
        item.appendChild(label);
      }

      var template =
        (window.themeVariables &&
          window.themeVariables.strings &&
          window.themeVariables.strings.slideCount) ||
        '@current@ of @total@';
      var text = template
        .replace('@current@', index + 1)
        .replace('@total@', total);
      if (label.textContent !== text) {
        label.textContent = text;
      }
      if (labelId && label.id !== labelId) {
        label.id = labelId;
      }
      if (labelId && item.getAttribute('aria-labelledby') !== labelId) {
        item.setAttribute('aria-labelledby', labelId);
      }
    });
  }

  function enhanceAllGalleries() {
    document
      .querySelectorAll('flickity-carousel.product__media-list')
      .forEach(enhanceGallery);
  }

  enhanceAllGalleries();

  // Flickity moves cells into its track and toggles is-selected/aria-hidden after
  // init, and variant selection toggles is-filtered — re-run on any of those,
  // debounced to once per frame. Idempotent writes let the observer settle quietly.
  var galleryUpdateScheduled = false;
  new MutationObserver(function () {
    if (galleryUpdateScheduled) return;
    galleryUpdateScheduled = true;
    requestAnimationFrame(function () {
      galleryUpdateScheduled = false;
      enhanceAllGalleries();
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden']
  });
})();

// Dialog trigger (ARIA dialog pattern) — the DashSocial/Lookfy "Learn More" buttons
// open a modal media/product lightbox, so each trigger must advertise that with
// aria-haspopup="dialog". The buttons are injected and re-rendered by the app, so we
// set it on load and whenever new cards appear.
(function () {
  function markDialogTriggers() {
    document.querySelectorAll('.media-action').forEach(function (btn) {
      if (btn.getAttribute('aria-haspopup') !== 'dialog') {
        btn.setAttribute('aria-haspopup', 'dialog');
      }
    });
  }

  markDialogTriggers();

  var dialogTriggerScheduled = false;
  new MutationObserver(function () {
    if (dialogTriggerScheduled) return;
    dialogTriggerScheduled = true;
    requestAnimationFrame(function () {
      dialogTriggerScheduled = false;
      markDialogTriggers();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

// WCAG 1.4.13 (Content on Hover or Focus) — the CSS [data-tooltip] utility (e.g.
// color-swatch names) shows a tooltip on hover/focus. Escape must dismiss it
// without requiring the pointer or focus to move. We flag the active element with
// data-tooltip-dismissed (CSS then hides its ::before/::after); the flag clears
// when the pointer leaves or focus exits, so hovering/focusing again shows it.
(function () {
  function armClear(el) {
    if (el.dataset.tooltipDismissArmed) return;
    el.dataset.tooltipDismissArmed = 'true';

    function clear() {
      el.removeAttribute('data-tooltip-dismissed');
    }
    el.addEventListener('mouseleave', clear);
    el.addEventListener('focusout', function (e) {
      if (!el.contains(e.relatedTarget)) clear();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc' && e.keyCode !== 27) return;

    var targets = [];

    // Elements currently under the pointer (hover-shown tooltip).
    try {
      document.querySelectorAll('[data-tooltip]:hover').forEach(function (el) {
        if (targets.indexOf(el) === -1) targets.push(el);
      });
    } catch (err) {}

    // Element holding keyboard focus (focus-within-shown tooltip).
    var active = document.activeElement;
    var focused = active && active.closest ? active.closest('[data-tooltip]') : null;
    if (focused && targets.indexOf(focused) === -1) targets.push(focused);

    if (!targets.length) return;

    targets.forEach(function (el) {
      el.setAttribute('data-tooltip-dismissed', '');
      armClear(el);
    });
  });
})();


